module.exports = "/img/story-1.64c492c7.png";